import { handleApiCall } from "../api";

export const getInvoiceList = (page: any, storeId: any) => handleApiCall("get", `invoices?page=${page}&limit=10&type=bill&store_id=${storeId}`);

export const getInvoiceById = (id: any) => handleApiCall("get", `invoices/${id}`)

export const statusUpdate = (id: any, payload: any) => handleApiCall("patch", `invoices/${id}`, payload);

/** Cancel invoice (Dashboard flow): PATCH invoices/:id with status cancelled. reason required when cancel_reason_id is 35. */
export const cancelInvoice = (
  id: number | string,
  payload: {
    status: string;
    cancel_reason_id: number;
    cancel_entire_order: boolean;
    reason?: string;
  }
) => handleApiCall("patch", `invoices/${id}`, payload);

export const getReturnInvoiceList = (page: any, storeId: any) => handleApiCall("get", `invoices?page=${page}&limit=10&type=return&store_id=${storeId}`)

// F&B : Orders History 
export const getInvoiceLists = (page: any, storeId: any, limit: number) => handleApiCall("get", `invoices?page=${page}&limit=${limit}&store_id=${storeId}&status=delivered&status=cancelled`);

export const getInvoiceByOrderId = (orderId: any, isOverall?: boolean | false) => {
  const url = isOverall ? `invoices/order/${orderId}?isOverall=true` : `invoices/order/${orderId}`;
  return handleApiCall("get", url);
}